import React from "react";
import { Link } from "react-router-dom";
import { Smartphone, QrCode, Download } from "lucide-react";
import { galleryImages } from "../../mock";

const NoAppSection = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1520854221256-17451cc331bf?crop=entropy&cs=srgb&fm=jpg&w=2000&q=70')] bg-cover bg-center opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-800/90 to-navy-700/85" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-cream-100">
            <p className="text-coral-300 tracking-widest text-sm font-semibold uppercase mb-4">2 mins to set up, it&apos;s so easy</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-[54px] leading-[1.1]">
              No app &amp; no guest registration — <span className="italic text-coral-300">guests just scan &amp; upload.</span>
            </h2>
            <p className="mt-6 text-cream-100/80 text-lg max-w-xl leading-relaxed">
              With GALERIECOP there&apos;s no need to ask all guests to download a photo sharing app or register. Your event QR code &amp; private link is how guests add their best photos, videos and guestbook messages. Everyone enjoys the memories instantly — and you can download everything in one click.
            </p>
            <div className="mt-8 grid sm:grid-cols-3 gap-4">
              {[
                { icon: QrCode, t: "Scan a code" },
                { icon: Smartphone, t: "Upload from any phone" },
                { icon: Download, t: "Download in HD" }
              ].map(({ icon: Icon, t }) => (
                <div key={t} className="flex items-center gap-3 bg-white/5 backdrop-blur border border-white/10 rounded-xl px-4 py-3">
                  <div className="w-9 h-9 rounded-lg bg-coral-300/20 text-coral-300 flex items-center justify-center"><Icon className="w-4 h-4" /></div>
                  <span className="text-sm font-medium">{t}</span>
                </div>
              ))}
            </div>
            <Link to="/how-it-works" className="mt-8 inline-flex items-center gap-2 bg-coral-300 text-white px-6 py-3 rounded-full font-semibold hover:bg-coral-400 transition-colors">
              See How It Works
            </Link>
          </div>

          <div className="relative flex justify-center">
            <div className="relative w-[260px] md:w-[300px] aspect-[9/19] bg-navy-900 rounded-[2.5rem] p-2 shadow-2xl ring-1 ring-white/10 rotate-[6deg]">
              <div className="w-full h-full bg-white rounded-[2rem] overflow-hidden relative">
                <div className="absolute top-2 left-1/2 -translate-x-1/2 w-20 h-5 bg-navy-900 rounded-full z-10" />
                <div className="h-full bg-cream-100 p-3 pt-8">
                  <div className="text-center font-serif italic text-navy-700 text-lg mb-3">Madison &amp; Aiden</div>
                  <div className="rounded-xl overflow-hidden mb-3">
                    <img src={galleryImages[2]} alt="" className="w-full h-44 object-cover" />
                  </div>
                  <div className="text-[10px] text-navy-700/70 text-center mb-2">Add your photos &amp; messages</div>
                  <button className="w-full bg-coral-300 text-white text-xs py-2 rounded-md font-semibold">+ Add to gallery</button>
                </div>
              </div>
            </div>
            <div className="absolute -left-6 md:left-2 top-12 w-[180px] aspect-square bg-white rounded-2xl shadow-2xl p-3 -rotate-[8deg]">
              <div className="w-full h-full bg-cream-100 rounded-lg flex items-center justify-center relative">
                <div className="absolute inset-2 bg-[radial-gradient(circle,#1B2E4A_1px,transparent_1px)] [background-size:8px_8px] rounded" />
                <div className="relative bg-white px-2 py-1 rounded text-[10px] font-bold text-navy-700">GALERIECOP</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoAppSection;
